import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
    .state('home', {
      url: '/',
      component: 'home',
      parent: 'main',
      redirectTo: 'tasks',
      data: {
        permissions: {
          only: ['AUTHORIZED'],
          redirectTo: 'login'
        }
      }
    });
})

.component('home', homeComponent)
.name;

export default homeModule;
